import { render } from "./AdminUsuaris.vue?vue&type=template&id=6df0f742"
import script from "./AdminUsuaris.vue?vue&type=script&lang=js"
export * from "./AdminUsuaris.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__